export default __webpack_public_path__ + "static/media/bisou.e10e5099.png";